const messageUtils = {
  data() {
    return {
      loading: 0,
      messageId: null,
      errorId: null
    };
  },
  computed: {
    isLoading: {
      get: function() {
        return this.loading > 0;
      },
      set: function(ignored) {}
    }
  },
  // watch: {
  //   isLoading: function() {
  //     if (this.loading > 0) {
  //       setTimeout(() => (this.loading = 0), 10000);
  //     }
  //   }
  // },
  methods: {
    clearMessage() {
      this.$store.commit('messageId/updateMessageIdSuccesState', null);
      this.$store.commit('messageId/updateMessageIdErrorState', null);
      this.defaultMessage = 'EF2143_Content';
    },
    setSuccessMessage(result) {
      this.errorId = null;
      this.messageId = result.messageId || this.defaultMessage;
      this.$store.commit('messageId/updateMessageIdSuccesState', this.messageId);
    },
    setErrorMessage(result) {
      this.messageId = null;
      this.errorId = result.messageId || this.defaultMessage;
      this.$store.commit('messageId/updateMessageIdErrorState', this.errorId);
    },
    updateMessage(status, result) {
      this.clearMessage();
      if (status === 0) {
        const errorId = result.messageId || this.defaultMessage;
        this.$store.commit('messageId/updateMessageIdErrorState', errorId);
      } else {
        const messageId = result.messageId || this.defaultMessage;
        this.$store.commit('messageId/updateMessageIdSuccesState', messageId);
      }
    }
  }
};

export default messageUtils;
